import React from "react";
import type { ButtonProps } from "@chakra-ui/react";
import { Button } from "@chakra-ui/react";
import { CardData } from "../pages/Ecard";

interface ECardDownloadProps extends ButtonProps {
  data: CardData;
}
const ECardDownload: React.FC<ECardDownloadProps> = ({ data, ...rest }) => {
  const buildVCard = (): string => {
    const lines: string[] = [
      "BEGIN:VCARD",
      "VERSION:3.0",
      `FN:${data.name}`,
      `ORG:${data.company}`,
    ];

    if (data.jobTitle) lines.push(`TITLE:${data.jobTitle}`);
    if (data.phone) lines.push(`TEL;TYPE=WORK,VOICE:${data.phone}`);
    if (data.email) lines.push(`EMAIL;TYPE=INTERNET:${data.email}`);
    if (data.url) lines.push(`URL:${data.url}`);
    if (data.linkedin)
      lines.push(`X-SOCIALPROFILE;type=linkedin:${data.linkedin}`);
    if (data.telegram)
      lines.push(`X-SOCIALPROFILE;type=telegram:${data.telegram}`);
    if (data.note) lines.push(`NOTE:${data.note}`);

    // Inline photo URL (not all clients support URL, but many do)
    if (data.imageUrl) lines.push(`PHOTO;VALUE=URL:${data.imageUrl}`);

    lines.push("END:VCARD");
    return lines.join("\n");
  };
  const handleDownload = (e: React.MouseEvent<HTMLButtonElement>) => {
    const vcardData = buildVCard();
    const blob = new Blob([vcardData], { type: "text/vcard;charset=utf-8" });
    const fileName = `contact_${data.name.replace(/\s+/g, "_")}`;

    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${fileName}.vcf`;
    a.click();

     setTimeout(() => URL.revokeObjectURL(url), 1000);
    (e.currentTarget as HTMLButtonElement).blur();
  };

  return (
    <Button onClick={handleDownload} {...rest}>
      Save Contact
    </Button>
  );
};

export default ECardDownload;
